import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';

const CarUnpublishedEmail = ({ content }) => {
  const { userName, carTitle, carId, logo, siteName } = content || {};
  const textStyle = {
    color: '#484848',
    backgroundColor: '#F7F7F7',
    fontFamily: 'Arial',
    fontSize: '16px',
    padding: '35px'
  };
  return (
    <Layout>
      <Header
        color="rgb(255, 90, 95)"
        backgroundColor="#F7F7F7"
        logo={logo}
        siteName={siteName}
      />
      <Body textStyle={textStyle}>
        <div>
          <h2>Your Car Listing Has Been Unpublished</h2>
          <p>Hi {userName || 'User'},</p>
          <p>
            We wanted to let you know that your car listing <strong>{carTitle || 'Car'}</strong> (ID: {carId}) has been unpublished by our team.
          </p>
          <p>
            If you have any questions or need further information, please contact our support team.
          </p>
          <p>
            Thank you for being part of our community.
          </p>
        </div>
        <EmptySpace height={30} />
      </Body>
      <Footer siteName={siteName} />
      <EmptySpace height={20} />
    </Layout>
  );
};

export default CarUnpublishedEmail;
